export const COLLECTION_TRAIT_ITEMS_TABLE_COLUMN_CLASSNAMES = {
  trait: "z-[1] w-[120px] grow-[2]",
  traitCount: "w-[120px] grow",
  items: "w-[240px] grow-[2]",
  traitFloor: "w-[120px] grow justify-end",
  bestOffer: "w-[120px] grow justify-end",
}
